import { UserMonth } from "app/redux/absencesTable/absencesTable.reducer"
import { Params as UserParams } from "app/redux/users/users.reducer"

export enum Types {
  SELECT = "SELECT_DAY",
  RESET = "RESET",
  GET = "GET_ABSENCES",
  GET_SUCCESS = "GET_ABSENCES_SUCCESS",
  GET_FAIL = "GET_ABSENCES_FAIL",
  SET_CLICKED_ROW = "SET_CLICKED_ROW",
}

type Date = {
  month: number
  year: number
}

export type Action =
  | SelectDayAction
  | GetAbsencesAction
  | GetAbsencesSuccessAction
  | GetAbsencesFailAction
  | SetClickedRow
  | ResetAction

export type GetAbsencesAction = {
  type: Types.GET
  payload: {
    params: { from: string; to: string }
    userParams: UserParams
    date?: Date
  }
}

export type GetAbsencesSuccessAction = {
  payload: { data: UserMonth[]; date: Date }
  type: Types.GET_SUCCESS
}

export type GetAbsencesFailAction = {
  payload: { errors: object }
  type: Types.GET_FAIL
}

export type SelectDayAction = {
  payload: { userId: string; date: string; selected: boolean }
  type: Types.SELECT
}

export type ResetAction = {
  type: Types.RESET
}

export type SetClickedRow = {
  payload: { userId: string }
  type: Types.SET_CLICKED_ROW
}

export function selectDay(userId: string, date: string, selected: boolean): SelectDayAction {
  return {
    payload: { userId, date, selected },
    type: Types.SELECT,
  }
}

export function getAbsences(
  params: { from: string; to: string },
  userParams: UserParams,
  date?: Date,
): GetAbsencesAction {
  return {
    type: Types.GET,
    payload: { params, date, userParams },
  }
}

export function getAbsencesSuccess(data: UserMonth[], date: Date): GetAbsencesSuccessAction {
  return {
    payload: { data, date },
    type: Types.GET_SUCCESS,
  }
}

export function getAbsencesFail(errors: object): GetAbsencesFailAction {
  return {
    payload: { errors },
    type: Types.GET_FAIL,
  }
}

export function setClickedRow(userId: string): SetClickedRow {
  return {
    payload: { userId },
    type: Types.SET_CLICKED_ROW,
  }
}

export function reset(): ResetAction {
  return {
    type: Types.RESET,
  }
}
